import { render, staticRenderFns } from "./AdvancePaymentRuleCreateOrUpdate.vue?vue&type=template&id=195cccad&"
import script from "./AdvancePaymentRuleCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AdvancePaymentRuleCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports